import { render } from "./CadastrarColaborador.vue?vue&type=template&id=17d9df5d&scoped=true"
import script from "./CadastrarColaborador.vue?vue&type=script&lang=js"
export * from "./CadastrarColaborador.vue?vue&type=script&lang=js"

import "./CadastrarColaborador.vue?vue&type=style&index=0&id=17d9df5d&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d9df5d"]])

export default __exports__